/**
 * Aynı ilanın farklı Emlakjet ID'leriyle listelenmesini engeller.
 */
export const listingUniqueKey = (item) => {
  const url = item?.url || "";
  if (url) {
    const slug = url.replace(/-\d+\/?$/, "").replace(/\/$/, "");
    if (slug.length > 6) return slug;
  }

  const title = (item?.title || "").trim().toLowerCase();
  const img = (item?.images || [])[0] || "";
  const price = item?.priceDetail?.price ?? item?.price ?? "";
  const city = item?.location?.city?.name || "";
  const district = item?.location?.district?.name || "";

  if (title && img) {
    return `${title}|${img}`;
  }

  return `${title}|${price}|${city}|${district}`;
};

export const dedupeListings = (list) => {
  if (!Array.isArray(list)) return [];
  const seen = new Set();
  return list.filter((item) => {
    const key = listingUniqueKey(item);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
